export { useAdminSettingsIndexPageNavigator } from "#use-admin-settings-index-page-navigator";
